import { referralCodeStore } from '@/stores'
import { useIsomorphicEffect } from '@codeleap/common'
import { useLocation } from '@reach/router'

export function usePopulateReferralCodeFromURL() {
  const { search } = useLocation()

  useIsomorphicEffect(() => {
    const queryParams = new URLSearchParams(search)
    const referralCode = queryParams.get('referral_code')?.trim()
    if (!referralCode) return

    const normalizedReferralCode = referralCode.toUpperCase()
    if (referralCodeStore.get() === normalizedReferralCode) return

    referralCodeStore.set(normalizedReferralCode)
  }, [search])
}
